/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["element"] }] */

export default async ({ block }) => {
  function getParameterByName(name) {
    const match = RegExp(`[?&]${name}=([^&]*)`).exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  if (getParameterByName('tracking_id')) {
    const arrayPlatformsElements = Array.from(block.querySelectorAll('.ui-site-platforms'));
    arrayPlatformsElements.forEach(element => {
      element.style.display = 'none';
    });

    const arrayAffiliateBannerElements = Array.from(block.querySelectorAll('.ui-site-affiliate-banner'));
    arrayAffiliateBannerElements.forEach(element => {
      element.style.display = 'flex';
    });
  }
};
